
export const initialDefaultFrame = -999999;
export const degToRads = Math.PI / 180;

export const defaultVector = [0, 0];
